import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Carriers_ds_get_carrierservices_by_carrierservicetypeId_top1Service {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { carrierservicetypeId: number }): 
  Promise<{ result: { CarrierId?: number, ServiceTypeId?: number } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.carrierservicetypeId)) {
      $missingRequiredInParams.push('\'carrierservicetypeId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      carrierservicetypeId: number    }) {
        if(isNil($inParams.carrierservicetypeId)) {
          return true; 
        }
      return false;
    }
}
